import { Component, Input } from '@angular/core';
import { StorageService } from './servicios/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

 constructor( public _storage:StorageService, public router:Router ) {

 }

  ngOnInit(){


  }



}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/app.component.ts